// CO4 — audio intensity crescendo. Pure helper mapping live combat pressure (swarm size + boss presence)
// to a music mix: the groove swells in volume, speeds a touch, and a driving kick layer fades in as the
// fight escalates — then settles when it calms. Audio-only, deterministic, headless-testable.

export interface IntensityMix {
  /** overall pressure 0..1 */
  level: number
  /** music gain multiplier (1 → calm, up to ~1.5 at peak) */
  musicGainMul: number
  /** seconds shaved off the music step (faster groove under pressure) */
  tempoBoost: number
  /** 0..1 amount of the driving kick/percussion layer */
  drive: number
}

export function intensityMix(enemyCount: number, bossActive: boolean): IntensityMix {
  const swarm = Math.min(1, Math.max(0, enemyCount) / 140)
  const level = Math.min(1, swarm * 0.85 + (bossActive ? 0.4 : 0))
  const drive = Math.min(1, Math.max(0, (level - 0.35) / 0.65)) // percussion kicks in past ~35% pressure
  return {
    level,
    musicGainMul: 1 + 0.5 * level,
    tempoBoost: 0.05 * level,
    drive,
  }
}
